import React from 'react';

export const YellowRibbonModalContent = () => (
  <div>
    <p>
      The Yellow Ribbon Program can help you pay for out-of-state, private
      school, or graduate school tuition that the Post-9/11 GI Bill doesn’t
      cover. Schools that choose to participate in the Yellow Ribbon program
      will contribute a certain amount toward the extra tuition. VA will match
      the participating school’s contribution, up to the total cost of the
      tuition and fees.
    </p>
    <p>
      <a
        href="/education/about-gi-bill-benefits/post-9-11/yellow-ribbon-program/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn more about the Yellow Ribbon Program
      </a>
      .
    </p>
    <p>
      <a
        href="/education/yellow-ribbon-participating-schools/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Visit the Yellow Ribbon tool
      </a>{' '}
      to find schools that participate in this program.
    </p>
  </div>
);

export default YellowRibbonModalContent;
